{
  "name": "@ns/company-turnover-confirmation",
  "version": "1.0.0",
  "description": "We found a turnover figure from your company's Companies House filings. Please confirm it's correct.",
  "inputs": {},
  "outcomes": {
    "complete": {},
    "dispute": {}
  }
}
